import './App.css';
import './styles/styles.css';
import './styles/font.css';
import './styles/loader.css';
import './styles/componentStyles.css';
import AppRoutes from './routes/appRoutes.js';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
function useExitOnBackAtRoot() {
  const location = useLocation();

  useEffect(() => {
    const handlePopState = () => {
      if (location.pathname === "/") {
        // Exit logic (redirect to blank or external site)
        window.location.href = "https://www.google.com"; // or a blank page
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [location]);
}


function App() {
  // useExitOnBackAtRoot();
  return <AppRoutes />
}

export default App;
